import { Col, Row } from '@opendoor/bricks-next';
import type { BoxProps } from '@opendoor/bricks-next';
import { Picture } from 'components/shared/performance/pictures';

import styles from './Marker.module.css';

export const MarkerPulseClassName = styles.markerPulse;

export const MarkerFadeInClassName = styles.markerFadeIn;

const Marker = ({
  imageSource,
  preload = false,
  lazy = true,
  animationDelay = '0s',
  ...props
}: {
  imageSource: string;
  preload?: boolean;
  lazy?: boolean;
  animationDelay?: string;
} & BoxProps) => {
  return (
    <Col
      position="absolute"
      {...props}
      style={{
        animationDelay,
      }}
    >
      <Row justifyContent="center" alignItems="center" width="100%">
        <Picture
          preload={preload}
          lazy={lazy}
          sources={[{ srcSet: imageSource, media: '(min-width: 0px)', key: imageSource }]}
          objectFit="cover"
        />
      </Row>
    </Col>
  );
};

export default Marker;
